module.exports = __webpack_public_path__ + "static/media/Owner.31adc77c.JPG";